import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ASSETS } from "@/lib/site";

const links = [
  { to: "/chi-sono", label: "Chi sono" },
  { to: "/servizi", label: "Servizi" },
  { to: "/prenota", label: "Prenota" },
  { to: "/faq", label: "FAQ" },
  { to: "/contatti", label: "Contatti" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-[#F6F8F3]/85 border-b border-[#CFD9C5]/60" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 flex items-center justify-between gap-4 h-20 lg:h-24">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 shrink-0">
          <img
            src={ASSETS.logo}
            alt="Chiara Maiolo Psicologa"
            className="h-12 w-12 lg:h-14 lg:w-14 object-contain"
          />
          <div className="hidden sm:flex flex-col leading-tight">
            <span className="font-serif-elegant text-lg lg:text-xl text-[#3D3B3A]">Chiara Maiolo</span>
            <span className="eyebrow" style={{ fontSize: "9px" }}>Psicologa</span>
          </div>
        </Link>

        <nav className="flex items-center gap-3 sm:gap-5 md:gap-7 lg:gap-9 overflow-x-auto no-scrollbar">
          {links.map((l) => {
            const active = location.pathname === l.to;
            return (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-link-${l.to.replace("/", "")}`}
                className={`text-[12px] sm:text-sm whitespace-nowrap transition-colors duration-300 ${
                  active
                    ? "text-[#7E9C7B] border-b border-[#7E9C7B] pb-1"
                    : "text-[#3D3B3A] hover:text-[#7E9C7B]"
                }`}
              >
                {l.label}
              </Link>
            );
          })}
        </nav>

        <Link
          to="/prenota"
          data-testid="nav-cta-prenota"
          className="hidden md:inline-flex shrink-0 items-center bg-[#9DB39A] text-white hover:bg-[#7E9C7B] rounded-full px-5 py-2.5 text-xs lg:text-sm transition-all duration-300"
        >
          Prenota
        </Link>
      </div>
    </header>
  );
}
